import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const WalmartProductListings = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12719"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12719)">
          <rect
            x="-4"
            y="-3"
            width="123"
            height="115"
            rx="5.2028"
            fill="#ECFEFF"
          />
          <rect
            x="24.3707"
            y="37.3258"
            width="60.4284"
            height="36.1292"
            rx="2.80903"
            fill="white"
            stroke="#191919"
            strokeWidth="0.959181"
          />
          <path
            d="M80.9223 37.4857L25.1699 71.5047C25.1699 71.5047 25.5615 72.4349 26.2586 72.7707C26.9556 73.1065 27.901 73.2951 28.8867 73.2951H80.9223C81.9081 73.2951 82.8535 73.1065 83.5505 72.7707C84.2476 72.4349 84.6391 71.9795 84.6391 71.5047V39.2762C84.6391 38.8013 84.2476 38.3459 83.5505 38.0101C82.8535 37.6744 80.9223 37.4857 80.9223 37.4857Z"
            fill="#E3E3E3"
          />
          <path
            d="M39.0295 45.796H60.771"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.0295 50.729H67.1655"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.0295 55.6621H60.771"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.0295 60.5948H67.1655"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M39.0295 65.5277H67.1655"
            stroke="#191919"
            strokeWidth="1.23323"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="24.3707"
            y="37.3258"
            width="60.4284"
            height="36.1292"
            rx="2.80903"
            stroke="#191919"
            strokeWidth="0.959181"
          />
          <path
            d="M10.2044 46.1914L11.7425 47.7295L16.8696 42.6024L15.3315 41.0643C14.6479 40.4025 13.7316 40.036 12.7802 40.0437C11.8287 40.0514 10.9185 40.4328 10.2457 41.1056C9.57294 41.7783 9.19156 42.6886 9.18384 43.64C9.17611 44.5914 9.54266 45.5078 10.2044 46.1914Z"
            fill="#FF808C"
          />
          <path
            d="M22.4683 58.4552L29.6462 60.506L27.5954 53.3281L22.4683 58.4552Z"
            fill="#FFBC44"
          />
          <path
            d="M16.8696 42.6046L27.5955 53.3305L22.4684 58.4576L11.7425 47.7317L16.8696 42.6046Z"
            fill="#FFEF5E"
          />
          <path
            d="M10.2044 46.1914L11.7425 47.7295L16.8696 42.6024L15.3315 41.0643C14.6479 40.4025 13.7316 40.036 12.7802 40.0437C11.8287 40.0514 10.9185 40.4328 10.2457 41.1056C9.57294 41.7783 9.19156 42.6886 9.18384 43.64C9.17611 44.5914 9.54266 45.5078 10.2044 46.1914Z"
            stroke="#191919"
            strokeWidth="0.959181"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.4683 58.4552L29.6462 60.506L27.5954 53.3281L22.4683 58.4552Z"
            stroke="#191919"
            strokeWidth="0.959181"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.8696 42.6046L27.5955 53.3305L22.4684 58.4576L11.7425 47.7317L16.8696 42.6046Z"
            stroke="#191919"
            strokeWidth="0.959181"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="71.6903"
            y="25.1762"
            width="33.5713"
            height="33.5713"
            rx="16.7857"
            fill="white"
          />
          <rect
            x="71.6903"
            y="25.1762"
            width="33.5713"
            height="33.5713"
            rx="16.7857"
            stroke="#1E1E1E"
            strokeWidth="0.959181"
          />
          <circle
            cx="88.4761"
            cy="41.9619"
            r="8.5"
            fill="#1D7AD9"
          />
          <path
            d="M88.4725 36.2952C88.0491 36.2952 87.7134 36.5365 87.7134 36.8295L87.971 39.7939C87.9984 39.9725 88.2135 40.1106 88.4738 40.1106C88.7342 40.1106 88.9479 39.9711 88.9767 39.7939L89.2356 36.8295C89.2356 36.5365 88.8972 36.2966 88.4738 36.2966L88.4725 36.2952ZM84.2826 38.6667C84.1495 38.6846 84.0227 38.7354 83.9133 38.8147C83.8039 38.894 83.7153 38.9993 83.6551 39.1215C83.4428 39.4954 83.4797 39.9125 83.7277 40.059L86.3776 41.3145C86.5433 41.3773 86.768 41.2573 86.8982 41.0355C87.0352 40.8053 87.0188 40.5473 86.8818 40.4329L84.4882 38.7253C84.4256 38.6893 84.3545 38.6714 84.2826 38.6737V38.6667ZM92.6637 38.6667C92.5918 38.6644 92.5207 38.6823 92.4581 38.7184L90.0645 40.4343C89.9275 40.5487 89.9179 40.8067 90.0481 41.0369C90.1783 41.2657 90.403 41.3857 90.5688 41.3159L93.2186 40.0604C93.4693 39.9139 93.5049 39.5024 93.2939 39.1229C93.2326 39.001 93.1428 38.8963 93.0324 38.818C92.922 38.7397 92.7945 38.6901 92.6609 38.6737L92.6637 38.6667ZM86.4776 42.5729C86.4439 42.5712 86.4103 42.5769 86.3789 42.5896L83.7291 43.8535C83.4797 44.0014 83.4428 44.4115 83.6551 44.7924C83.8675 45.1732 84.2402 45.342 84.4882 45.1955L86.8818 43.4908C87.0188 43.375 87.0297 43.1169 86.8996 42.8881C86.8597 42.8058 86.8001 42.735 86.7264 42.6821C86.6527 42.6292 86.5671 42.596 86.4776 42.5854V42.5729ZM90.4701 42.5729C90.3805 42.5834 90.295 42.6167 90.2213 42.6695C90.1475 42.7224 90.088 42.7933 90.0481 42.8756C89.9111 43.1044 89.9289 43.3625 90.0659 43.4782L92.4595 45.1983C92.7075 45.3378 93.0802 45.1676 93.2939 44.7952C93.5077 44.4227 93.4693 44.0042 93.2186 43.8563L90.5688 42.598C90.5374 42.5854 90.5038 42.5797 90.4701 42.5812V42.5729ZM88.4725 43.8145C88.2135 43.8145 87.9984 43.954 87.971 44.1297L87.7134 47.0942C87.7134 47.3872 88.0505 47.6285 88.4738 47.6285C88.8972 47.6285 89.2356 47.3872 89.2356 47.0942L88.9767 44.1325C88.9479 43.954 88.7342 43.8172 88.4738 43.8172L88.4725 43.8145Z"
            fill="#FFC220"
          />
          <g clipPath="url(#clip0_1529_12719)">
            <path
              d="M86.8521 76.0024H73.0645C72.7592 76.0024 72.4618 75.9049 72.2158 75.724C71.9697 75.5431 71.788 75.2883 71.697 74.9968L70.2052 70.2217C70.1383 70.0073 70.1227 69.7802 70.1597 69.5586C70.1968 69.3371 70.2854 69.1274 70.4184 68.9464C70.5514 68.7654 70.7251 68.6183 70.9255 68.5168C71.1258 68.4153 71.3473 68.3624 71.5719 68.3623H87.9198C88.1266 68.363 88.3279 68.2959 88.4929 68.1713L87.6161 76.371C87.5291 76.2513 87.4138 76.155 87.2805 76.0907C87.1472 76.0264 87 75.996 86.8521 76.0024Z"
              fill="#C2F3FF"
            />
            <path
              d="M74.8714 73.2461C74.5663 73.246 74.2693 73.1485 74.0234 72.9678C73.7776 72.7871 73.5959 72.5326 73.5048 72.2415L72.2919 68.3622H71.5719C71.3473 68.3623 71.1258 68.4152 70.9255 68.5167C70.7251 68.6182 70.5514 68.7654 70.4184 68.9463C70.2854 69.1273 70.1968 69.337 70.1597 69.5586C70.1227 69.7801 70.1383 70.0072 70.2052 70.2216L71.697 74.9967C71.788 75.2882 71.9697 75.543 72.2158 75.7239C72.4618 75.9048 72.7592 76.0024 73.0645 76.0023H86.8521C87 75.996 87.1471 76.0264 87.2804 76.0907C87.4137 76.155 87.5291 76.2513 87.6162 76.371L87.9495 73.2461H74.8714Z"
              fill="#66E1FF"
            />
            <path
              d="M92.1047 64.5418H89.6618C89.5446 64.5409 89.4312 64.5831 89.3432 64.6604C89.2551 64.7377 89.1986 64.8447 89.1843 64.961L88.8672 67.5243C88.8386 67.7554 88.7265 67.9681 88.552 68.1223C88.3775 68.2766 88.1527 68.3617 87.9198 68.3618H71.5719C71.3473 68.362 71.1258 68.4149 70.9255 68.5164C70.7251 68.6178 70.5514 68.765 70.4184 68.946C70.2854 69.127 70.1968 69.3367 70.1597 69.5582C70.1227 69.7797 70.1383 70.0069 70.2052 70.2213L71.697 74.9963C71.788 75.2878 71.9697 75.5426 72.2158 75.7235C72.4618 75.9045 72.7592 76.002 73.0645 76.002H86.8521C87.1054 76.002 87.3483 76.1026 87.5274 76.2817C87.7065 76.4608 87.8072 76.7037 87.8072 76.957C87.8072 77.2103 87.7065 77.4532 87.5274 77.6323C87.3483 77.8114 87.1054 77.912 86.8521 77.912H73.4819"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M88.2856 70.272L87.8635 74.071"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M75.393 82.6876C75.7729 82.6876 76.1373 82.5366 76.4059 82.268C76.6746 81.9993 76.8255 81.635 76.8255 81.255C76.8255 80.8751 76.6746 80.5107 76.4059 80.2421C76.1373 79.9734 75.7729 79.8225 75.393 79.8225C75.013 79.8225 74.6487 79.9734 74.38 80.2421C74.1114 80.5107 73.9604 80.8751 73.9604 81.255C73.9604 81.635 74.1114 81.9993 74.38 82.268C74.6487 82.5366 75.013 82.6876 75.393 82.6876Z"
              fill="#D7D7D7"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M85.8981 82.6876C86.278 82.6876 86.6424 82.5366 86.9111 82.268C87.1797 81.9993 87.3306 81.635 87.3306 81.255C87.3306 80.8751 87.1797 80.5107 86.9111 80.2421C86.6424 79.9734 86.278 79.8225 85.8981 79.8225C85.5182 79.8225 85.1538 79.9734 84.8852 80.2421C84.6165 80.5107 84.4656 80.8751 84.4656 81.255C84.4656 81.635 84.6165 81.9993 84.8852 82.268C85.1538 82.5366 85.5182 82.6876 85.8981 82.6876Z"
              fill="#D7D7D7"
              stroke="#191919"
              strokeWidth="0.959181"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_1529_12719">
            <rect
              width="23.6598"
              height="23.6598"
              fill="white"
              transform="translate(69.2922 61.7844)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
WalmartProductListings.displayName = 'WalmartProductListings';
